import axios from 'axios';
import { URLS, HTTP_METHODS } from '../helpers/constants';

class CostFileTemplateProxy {
  static async getTemplate(suvc) {
    const response = await axios({
      url: `${URLS.COST_FILE_TEMPLATES_URL}/${suvc}`,
      method: HTTP_METHODS.GET,
    });
    return response.data;
  }

  static async createTemplate({ suvc, templateName, columns }) {
    const response = await axios({
      url: URLS.COST_FILE_TEMPLATES_URL,
      method: HTTP_METHODS.POST,
      data: { suvc, templateName, columns },
    });
    return response.data;
  }

  static async updateTemplate({ templateId, templateName, columns }) {
    const response = await axios({
      url: `${URLS.COST_FILE_TEMPLATES_URL}/${templateId}`,
      method: HTTP_METHODS.PATCH,
      data: { templateName, columns },
    });
    return response.data;
  }

  static async deleteTemplate(templateId) {
    const response = await axios({
      url: `${URLS.COST_FILE_TEMPLATES_URL}/${templateId}`,
      method: HTTP_METHODS.DELETE,
    });
    return response.data;
  }
}

export default CostFileTemplateProxy;
